import { IMassArrivalFilter } from "../types";

export const initialFilterValues: IMassArrivalFilter = {
  PortOfDischargeIds: undefined,
  CompanyCodes: undefined,
  _minMassArrivalDate: undefined,
  _maxMassArrivalDate: undefined
}